import React, { Component } from 'react';

// Material UI Imports
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardHeader from "@material-ui/core/CardHeader";
import CardText from "@material-ui/core/CardContent";

import { withStyles } from '@material-ui/core/styles';

// Components Imports
import AsyncImage from './AsyncImage';


const styles = {
  avatar: {
    margin: "5px 20px 5px 5px",
    borderRadius: 0,
    width: 25,
    height: 25

  },

  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-wrap',
  },
  gridList: {
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto',
  },
  gridTile: {
    transform: 'rotate(90deg)',
    margin: '30px -20px'

  },

  card: {
    marginTop: 0,
    marginBottom: 0,
    boxShadow: "none",
  },
  text: {
    paddingTop: 0,
    paddingBottom: 10,
    paddingLeft: 65,
  },
  title: {
    padding: "8px 0",
    fontWeight: 400,
    fontSize: 14
  },
  subheader: {
    fontWeight: 400,
  },
}

class Question extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: true,
    };
  }

  render() {

    const { classes } = this.props;

    return (
      <Card className={classes.card} elevation={0}>
        <CardHeader
          titleTypographyProps={{ variant: "subtitle1" }}
          title={"Q. " + this.props.question.statement}
          subheader={"A. " + this.props.question.answer}
          avatar={<Avatar className={classes.avatar}>
            <div style={{ fontSize: 12 }}>
              {this.props.question.position}
            </div>

          </Avatar>}
          subheaderTypographyProps={{ variant: "body2", color:'textSecondary' }}
        />
        <CardText>
          <div className={classes.text}>
            {this.props.question.comment}
          </div>

          <div className={classes.root}>
            {this.props.question.images.map((tile, id) => (
              <div key={id} className={classes.gridTile}>
                <AsyncImage key={id} projectId={tile.project.id} imageId={tile.id} size="1000x1000" />
              </div>
            ))}

          </div>
        </CardText>        
      </Card>
    );
  }
}

export default withStyles(styles)(Question);


// WEBPACK FOOTER //
// src/components/innerComponents/Question.js